import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StartingScreen from "./screens/StartingScreen/StartingScreen";
import LoginScreen from "./screens/LoginScreen/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen/RegisterScreen";
import LandingScreen from "./screens/LandingScreen/LandingScreen";
import FixedCostScreen from "./screens/FixedCostScreen/FixedCostScreen";
import VariableCostScreen from "./screens/VariableCostScreen/VariableCostScreen";
import WeeklyBreakdown from "./screens/WeeklyBreakdown/WeeklyBreakdown";
import Result from "./screens/Result/Result";
import SettingsScreen from "./screens/SettingsScreen/SettingsScreen";
//
import AdminStartingScreen from "./screens/AdminScreens/AdminStartingScreen/AdminStartingScreen";
import AdminLoginScreen from "./screens/AdminScreens/AdminLoginScreen/AdminLoginScreen";
import AdminLandingScreen from "./screens/AdminScreens/AdminLandingScreen/AdminLandingScreen";
import AdminAddLinkScreen from "./screens/AdminScreens/AdminAddLinkScreen/AdminAddLinkScreen";
import AdminSettingsScreen from "./screens/AdminScreens/AdminSettingsScreen/AdminSettingsScreen";

/**Firebase Imports**/
import { db, getDoc, doc, auth, onAuthStateChanged } from "./firebaseConfig";
import { logIn, logOut, useDispatch } from "./features/userSlice";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
/** **/
function App() {
	const dispatch = useDispatch();

	/**
	 * Check If Logged In
	 */
	useEffect(() => {
		const checkAuthState = () =>
			onAuthStateChanged(auth, async (user) => {
				if (user) {
					// User is signed in
					const docRef = doc(db, "users", auth.currentUser.uid);
					const docSnap = await getDoc(docRef);
					if (docSnap.exists()) {
						dispatch(
							logIn({
								uid: user.uid,
								email: user.email,
								name: user.displayName,
								role: docSnap.data().isAdmin === true ? "admin" : "user",
							})
						);
					}
				} else {
					// User is signed out
					dispatch(logOut());
				}
			});

		checkAuthState();
		return () => console.log("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	/** **/

	return (
		<div className="App">
			<BrowserRouter>
				<Routes>
					{/* User */}
					<Route
						path="/"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={true}
								component={<StartingScreen />}
							/>
						}
					/>
					<Route
						path="/login"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={true}
								component={<LoginScreen />}
							/>
						}
					/>
					<Route
						path="/register"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={true}
								component={<RegisterScreen />}
							/>
						}
					/>
					<Route
						path="/landing"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={false}
								component={<LandingScreen />}
							/>
						}
					/>
					<Route
						path="/fixedcost"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={false}
								component={<FixedCostScreen />}
							/>
						}
					/>
					<Route
						path="/variablecost"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={false}
								component={<VariableCostScreen />}
							/>
						}
					/>
					<Route
						path="/weeklycost"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={false}
								component={<WeeklyBreakdown />}
							/>
						}
					/>
					<Route
						path="/result"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={false}
								component={<Result />}
							/>
						}
					/>
					<Route
						path="/settings"
						element={
							<ProtectedRoute
								adminRoute={false}
								loginRoute={false}
								component={<SettingsScreen />}
							/>
						}
					/>

					{/* Admin */}
					<Route
						path="/admin"
						element={
							<ProtectedRoute
								adminRoute={true}
								loginRoute={true}
								component={<AdminStartingScreen />}
							/>
						}
					/>
					<Route
						path="/admin/login"
						element={
							<ProtectedRoute
								adminRoute={true}
								loginRoute={true}
								component={<AdminLoginScreen />}
							/>
						}
					/>
					<Route
						path="/admin/landing"
						element={
							<ProtectedRoute
								adminRoute={true}
								loginRoute={false}
								component={<AdminLandingScreen />}
							/>
						}
					/>
					<Route
						path="/admin/addLink"
						element={
							<ProtectedRoute
								adminRoute={true}
								loginRoute={false}
								component={<AdminAddLinkScreen />}
							/>
						}
					/>
					<Route
						path="/admin/settings"
						element={
							<ProtectedRoute
								adminRoute={true}
								loginRoute={false}
								component={<AdminSettingsScreen />}
							/>
						}
					/>

					{/* 404 Not Found */}
					<Route
						path="/*"
						element={
							<div className="h-full w-full flex items-center justify-center">
								<h1 className="text-2xl">
									404
									<br /> Page Not Found
								</h1>
							</div>
						}
					/>
					{/****/}
				</Routes>
			</BrowserRouter>
		</div>
	);
}

export default App;
